import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";

import theme from "@theme/index";

interface IIndustryChipProperties {
  isPreferredIndustry?: boolean;
  isSelected?: boolean;
  sector: string;
  setIndustry: (sector: string) => void;
}

export default function IndustryChip({
  isPreferredIndustry = false,
  isSelected = false,
  sector,
  setIndustry,
}: IIndustryChipProperties) {
  return (
    <Tooltip key={sector} title="Click to add industry filter.">
      <Chip
        color="secondary"
        label={sector}
        onClick={() => setIndustry(sector)}
        size="small"
        sx={{
          // whiteSpace: 'nowrap', // Ensure the text doesn't wrap
          ":hover": {
            backgroundColor: `${theme.palette.primary.main} !important`,
            borderColor: `${theme.palette.primary.main} !important`,
            color: theme.palette.common.white,
          },
          backgroundColor: isSelected ? `${theme.palette.primary.main} !important` : theme.palette.common.white,
          borderColor:
            isSelected || isPreferredIndustry
              ? `${theme.palette.primary.main} !important`
              : theme.palette.secondary.main,
          color: isSelected
            ? theme.palette.common.white
            : isPreferredIndustry
              ? theme.palette.primary.main
              : theme.palette.secondary.main,
          fontWeight: isPreferredIndustry ? 600 : undefined,
          mr: 1,
          px: 0.5,
          // overflow: 'hidden', // Ensure no overflow
          textOverflow: "ellipsis", // Use ellipsis if the text overflows
          transition: "all .2s ease-in-out",
        }}
        variant="outlined"
      />
    </Tooltip>
  );
}
